export default "__VITE_ASSET__9eaa2ee9__"